import { usePaymentInputs } from '../hooks';

export default function PaymentInputsContainer( props ) {
	const paymentInputs = usePaymentInputs( props );
	return props.children( paymentInputs );
}
